/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Error_HandledInputs */

const en_agent_authorization_error_handled = /** @type {(inputs: Agent_Authorization_Error_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This authorization request was already approved, rejected, or expired. Reload the page to see its current state.`)
};

const zh_agent_authorization_error_handled = /** @type {(inputs: Agent_Authorization_Error_HandledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该授权请求已被批准、拒绝或已过期。刷新页面查看最新状态。`)
};

/**
* | output |
* | --- |
* | "This authorization request was already approved, rejected, or expired. Reload the page to see its current state." |
*
* @param {Agent_Authorization_Error_HandledInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_error_handled = /** @type {((inputs?: Agent_Authorization_Error_HandledInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Error_HandledInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_error_handled(inputs)
	return zh_agent_authorization_error_handled(inputs)
});
export { agent_authorization_error_handled as "agent.authorization.error.handled" }